import { media } from '../../styles/styled-components'
import styled, { css } from 'styled-components'

export default styled.h1`
  font-size: 3.2rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Book };
  letter-spacing: -0.01em;
  line-height: 1.19;
  margin-bottom: 20px;
  text-align: center;
  strong {
    color: ${ ({ theme }) => theme.colors.mint };
    font-weight: 700;
  }
  ${ media.tablet`
    line-height: 1.2;
    font-size: 4.6rem;
    margin-bottom: 25px;
    ${ ({ scAlignTextToLeft }) => scAlignTextToLeft && css`
      text-align: left;
    ` }
  ` }

  ${ media.desktop`
    line-height: normal;
    font-size: 6.4rem;
    margin-bottom: 30px;
    text-align: ${ ({ scAlignTextToCenter }) => scAlignTextToCenter ? 'center' : 'left' }
  ` }
`
